module.exports = __webpack_public_path__ + "img/droplet-degree.7cc5d9e8.svg";